/** 项目章节模型调用的用量与价格快照；未知用量不表示免费，费用仅为可对账估算。 */
import { z } from 'zod';

const TokenCountSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
const UnitPriceSchema = z.string().regex(/^\d{1,8}(?:\.\d{1,6})?$/);
export const LandingAiTokenUsageSchema = z
  .object({
    input_tokens: TokenCountSchema,
    output_tokens: TokenCountSchema,
    total_tokens: TokenCountSchema,
    cached_input_tokens: TokenCountSchema.nullable(),
  })
  .strict();
export type LandingAiTokenUsage = z.infer<typeof LandingAiTokenUsageSchema>;
export const LandingAiPriceSnapshotSchema = z
  .object({
    currency: z.literal('USD'),
    input_per_million: UnitPriceSchema,
    output_per_million: UnitPriceSchema,
    cached_input_per_million: UnitPriceSchema.nullable(),
    source_url: z.url(),
    verified_on: z.iso.date(),
  })
  .strict();
export type LandingAiPriceSnapshot = z.infer<typeof LandingAiPriceSnapshotSchema>;
export interface LandingAiUsageSummary {
  tracking_status: 'RECORDED' | 'LEGACY_UNKNOWN' | 'REUSED';
  call_count: number;
  known_usage_calls: number;
  unknown_usage_calls: number;
  unpriced_calls: number;
  input_tokens: string;
  output_tokens: string;
  cached_input_tokens: string | null;
  estimated_cost_usd: string | null;
  known_cost_usd: string;
}
export interface LandingAiModelCallDto {
  id: string;
  stage: string;
  batch_index: number | null;
  provider: string;
  model: string;
  status: 'STARTED' | 'COMPLETED' | 'FAILED';
  usage: LandingAiTokenUsage | null;
  price_snapshot: LandingAiPriceSnapshot | null;
  estimated_cost_usd: string | null;
  created_at: string;
  finished_at: string | null;
}
